// DO NOT EDIT -- generated from fs/services/webber/conversions/funnels.proto

import * as display from '../frontend/display';
import * as protobuf from '../../../../google/protobuf';

export namespace FunnelsPublic {

  export const GetRevenueEventEndpoint = "/grpc/funnels.FunnelsPublic/GetRevenueEvent";
  /** GetRevenueEvent */
  export function GetRevenueEvent(sender: (req: RevenueEventRequest, endpoint: string) => Promise<RevenueEventResponse>, req: RevenueEventRequest): { promise: () => Promise<RevenueEventResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetRevenueEventEndpoint),
      endpoint: GetRevenueEventEndpoint
    };
  }

  export const CreateRevenueEventEndpoint = "/grpc/funnels.FunnelsPublic/CreateRevenueEvent";
  /** CreateRevenueEvent */
  export function CreateRevenueEvent(sender: (req: CreateRevenueEventRequest, endpoint: string) => Promise<RevenueEventResponse>, req: CreateRevenueEventRequest): { promise: () => Promise<RevenueEventResponse>, endpoint: string } {
    return {
      promise: () => sender(req, CreateRevenueEventEndpoint),
      endpoint: CreateRevenueEventEndpoint
    };
  }

  export const UpdateRevenueEventEndpoint = "/grpc/funnels.FunnelsPublic/UpdateRevenueEvent";
  /** UpdateRevenueEvent */
  export function UpdateRevenueEvent(sender: (req: UpdateRevenueEventRequest, endpoint: string) => Promise<RevenueEventResponse>, req: UpdateRevenueEventRequest): { promise: () => Promise<RevenueEventResponse>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateRevenueEventEndpoint),
      endpoint: UpdateRevenueEventEndpoint
    };
  }

  export const DeleteRevenueEventEndpoint = "/grpc/funnels.FunnelsPublic/DeleteRevenueEvent";
  /** DeleteRevenueEvent */
  export function DeleteRevenueEvent(sender: (req: DeleteRevenueEventRequest, endpoint: string) => Promise<{}>, req: DeleteRevenueEventRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteRevenueEventEndpoint),
      endpoint: DeleteRevenueEventEndpoint
    };
  }
}

export interface RevenueEventRequest {
  orgId: string;
}

export interface RevenueEventResponse {
  revenueEvent: RevenueEvent | null;
}

/** This is used to configure a custom event that is used for Revenue Attribution */
export interface RevenueEvent {
  id: protobuf.int64;
  eventName?: string;
  definedEventId?: string;
  eventProperty: string;
  currency: display.DisplayCurrencyType;
  disabled: boolean;
}

/** This is used to configure a custom event that is used for Revenue Attribution */
export namespace RevenueEvent {
  export enum event {
    eventName = 3,
    definedEventId = 6
  }

  export function event_oneof(m: RevenueEvent): { opt: event.definedEventId, val: string } | { opt: event.eventName, val: string } | null {
    if (m.eventName != null) { return { opt: event.eventName, val: m.eventName } }
    if (m.definedEventId != null) { return { opt: event.definedEventId, val: m.definedEventId } }
    return null;
  }
}

export interface CreateRevenueEventRequest {
  orgId: string;
  revenueEvent: RevenueEvent | null;
}

export interface UpdateRevenueEventRequest {
  orgId: string;
  revenueEvent: RevenueEvent | null;
}

export interface DeleteRevenueEventRequest {
  orgId: string;
}
